import { Component, Input, ViewChild } from '@angular/core';
import { CommonModalComponent } from 'src/app/_metronic/shared/components/common-modal/common-modal.component';
import { IMediaInfo } from 'src/app/types/interfaces/common.interface';

@Component({
  selector: 'app-media-gallery-modal',
  templateUrl: './media-gallery-modal.component.html',
  styleUrls: ['./media-gallery-modal.component.scss']
})
export class MediaGalleryModalComponent {
  @Input() modalTitle:string;
  @Input() mediaList: IMediaInfo[];
  @ViewChild('modal') private modalComponent: CommonModalComponent;
  async openModal() {
    return await this.modalComponent.open();
  }
}
